import { render, staticRenderFns } from "./PersonalizationObuTable.vue?vue&type=template&id=724e1910&"
import script from "./PersonalizationObuTable.vue?vue&type=script&lang=js&"
export * from "./PersonalizationObuTable.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizationObuTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports